module.exports = __webpack_public_path__ + "img/adaptin.cf99c856.png";